import styled from '@emotion/styled'

export const StyleFaqRow = styled.div<{ isLast?: boolean; isActive?: boolean }>`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  column-gap: 20px;
  width: 100%;
  padding: 20px 10px;
  margin-bottom: 10px;
  border-radius: 8px;
  background-color: ${(props) => (props.isActive ? '#f8f9ff' : 'transparent')};
  border-bottom: 1px solid
    ${(props) => (props.isActive ? '#d6e0ff' : '#e9e9e9')};
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    background-color: #f8f9ff;
    border-color: #d6e0ff;
  }

  @media (max-width: 768px) {
    padding: 15px;
  }
`

export const StyleFaqTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  flex: 1;
`

export const StyleListWrapper = styled.ul`
  list-style-type: none;
  padding-left: 15px;
  margin: 5px 0;
`

export const StyleList = styled.li`
  margin-bottom: 5px;
  position: relative;
  padding-left: 15px;

  &::before {
    content: '•';
    position: absolute;
    left: 0;
    color: #2a3cce;
    font-weight: bold;
  }
`
